  <h5>FRT Query Results</h5>
  <p style="color: #8F0808">
    Socio Economic Indicator:
    s - Small Business, o	- Other than Small Business, w -	Woman Owned Business, v - Veteran Owned Small Business, dv - Service Disabled VOSB ,
    d - SBA Certified Small Disadvantaged Business, 8a -	SBA Certified 8(a) firm, h -	SBA Certified HUBZone firm
  </p>
  <p *ngIf="isPickupDatePastDate">
    <span class="frt-suspended-tsp">
      Suspended TSPs are listed in yellow.
    </span>
  </p>
  <div class="usa-card" [hidden]="!showBody">
    <app-user-pref-body [screenName] = "this.screenName" (updateTable)="updateListPrefs($event)"></app-user-pref-body>
  </div>
  <div class="grid-row padding-y-4" *ngIf="showGrid">
    <ul class="usa-button-group">
      <!-- <li class="usa-button-group__item">
        <button type="button" class="usa-button" (click)="onBtExport()">Export to CSV</button> 
      </li> -->
      <li class="usa-button-group__item" *ngIf="!showBody">
        <button type="button" class="usa-button" (click)="gotoUserPrefs()">Set data view preferences</button> 
      </li>
      <li class="usa-button-group__item" *ngIf="showBody">
        <button type="button" class="usa-button" (click)="closeUserPrefs()">Close data view preferences</button> 
      </li>
      <li class="usa-button-group__item">
        <button type="button" class="usa-button usa-button--base usa-button--hover" (click)="onBtPrint()">Print Results</button>
      </li>
    </ul>
  </div>
  <div class="grid-row" *ngIf="!showGrid">
    <p class="align-content-center">No approved TSPs available for the selected query. Please adjust your query options.</p>
  </div>
  <div  *ngIf="showGrid">
    <ag-grid-angular
      style="width: 100%; height: 400px;"
      id="myGrid"
      class="ag-theme-alpine"
      [columnDefs]="columnsDefs"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [suppressDragLeaveHidesColumns]="true"
      (gridReady)="onGridReady($event)"
      ag-grid-resize>
    </ag-grid-angular>
  </div>
    
  
  

